import { render, staticRenderFns } from "./hotsale.vue?vue&type=template&id=6cd6d5cb&scoped=true&"
import script from "./hotsale.vue?vue&type=script&lang=js&"
export * from "./hotsale.vue?vue&type=script&lang=js&"
import style0 from "./hotsale.vue?vue&type=style&index=0&id=6cd6d5cb&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cd6d5cb",
  null
  
)

export default component.exports